import * as types from '../mutation-types'
import { http } from '../../lib/http'

const state = {
    query: {
        filter: null,
        categories: [],
        sort: null
    },
    counters: {
        total: 0,
        my: 0,
        starred: 0,
        moderation: 0
    },
    currentIdeaId: null,
    idea: {},
    ideas: [],
    paging: {},
    currentPage: 1,
    totalPages: 1,
    categories: [],
    selectedCategories: [],
    rootCategories: [],
    categoriesById: {},
    categoriesByParentId: {}
}

const getters = {
    getCategoryTitle: (state) => (id) => {
        return state.categoriesById[id];
    }
}

var mutations = {
    'SET_CURRENT_IDEA_ID' (state, data) {
        state.currentIdeaId = data
    },

    'SET_IDEA' (state, data) {
        if (data && data.comment) {
            data.commentList = _.groupBy(data.comment, 'parent_id');
            data.rootComments = (data.commentList && data.commentList['null']) ? data.commentList['null'] : [];
        }
        state.idea = data;
    },

    'UPDATE_IDEA' (state, payload) {
        state.idea = Object.assign({}, state.idea, payload.data);
        let ideas = [ ...state.ideas ];
        let i = ideas.findIndex(idea => idea.id === payload.ideaId);
        ideas[i] = Object.assign({}, ideas[i], payload.data);
        state.ideas = ideas;
    },

    'DELETE_IDEA' (state, payload) {
        let ideas = [ ...state.ideas ];
        let i = ideas.findIndex(idea => idea.id === payload.ideaId);
        ideas.splice(i, 1);
        state.ideas = ideas;
    },

    'SET_CATEGORIES' (state, data) {
        state.categoriesByParentId = _.groupBy(data, 'parent_id');
        state.categoriesById = _.keyBy(data, 'id');
        state.rootCategories = (state.categoriesByParentId && state.categoriesByParentId['null']) ? state.categoriesByParentId['null'] : [];

        // сортировка по parent_id как дерево

        let categories = _.cloneDeep(state.rootCategories);

        // в обратном порядке для сохранения алфавитного порядка
        data.reverse().forEach((category, myIndex) => {
            if (category.parent_id) {
                let parentItem = _.find(categories, {id: category.parent_id});
                let parentIndex = categories.indexOf(parentItem);
                categories.splice(parentIndex + 1, 0, category);
            }
        });
        state.categories = categories;
    },

    'SET_IDEAS' (state, data) {
        data.forEach((idea) => {
            idea.categories = [];
            if (data.category_id) {
                let cat = state.categoriesById[data.category_id];
                idea.categories.push(cat);

                if (cat.parent_id) {
                    idea.categories.push(state.categoriesById(cat.parent_id));
                }
            }
        });

        state.ideas = data;
    },

    'MORE_IDEAS' (state, data) {
        data.forEach((idea) => {
            idea.categories = [];
            if (data.category_id) {
                let cat = state.categoriesById[data.category_id];
                idea.categories.push(cat);

                if (cat.parent_id) {
                    idea.categories.push(state.categoriesById(cat.parent_id));
                }
            }
        });

        state.ideas = [...state.ideas, ...data]
    },

    'SET_CURRENT_PAGE' (state, page) {
        state.currentPage = page
    },

    'SET_TOTAL_PAGES' (state, total) {
        state.totalPages = total
    },

    'SELECT_CATEGORIES' (state, categories) {
        state.selectedCategories = categories;
    }

}

const objects = ['paging', 'query', 'counters'];

objects.forEach((obj) =>{
    var key = 'SET_'+obj.toUpperCase();
    if (!mutations[key]) {
        mutations[key] = (state, data) => {
            state[obj] = data
        };
    }
});


const actions = {
    setCurrentIdeaId({state, commit, dispatch}, ideaId) {
        // проверка, чтобы страница аккаунта не перезагружалась при переходе по вкладкам
        if (state.currentIdeaId !== ideaId) {
            commit('SET_CURRENT_IDEA_ID', ideaId)
        }
        if (ideaId) {
            dispatch('loadIdea')
        } else {
            commit('SET_IDEA', {});
        }
    },

    queryToggleCategory({state, commit, dispatch}, categoryId) {
        let arr = state.query;

        let mode = null;

        let i = arr.categories.indexOf(categoryId);
        if (i > -1) {
            arr.categories.splice(i, 1);
            mode = 'remove';
        } else {
            arr.categories.push(categoryId);
            mode = 'add';
        }

        if (state.categoriesByParentId[categoryId]) {
            state.categoriesByParentId[categoryId].forEach((cat) => {
                console.log(cat);

                let i = arr.categories.indexOf(cat.id);

                if (mode === 'remove' && i > -1) {
                    arr.categories.splice(i, 1);
                } else if (i === -1) {
                    arr.categories.push(cat.id);
                }
            })
        }

        commit('SELECT_CATEGORIES', arr.categories);
        commit('SET_QUERY', arr);
        dispatch('loadIdeas');
    },

    querySetCategory({state, commit, dispatch}, categoryId) {
        let arr = state.query;
        arr.categories = categoryId ? [categoryId] : [];
        commit('SET_QUERY', arr);
        dispatch('loadIdeas');
    },

    loadIdeas({ commit }, page = 1) {
        let query = Object.assign({}, state.query, { page })
        http.post('/api/ideas', query).then((data) => {
            if (data) {
                if (data.items) {
                    page > 1
                        ? commit('MORE_IDEAS', data.items)
                        : commit('SET_IDEAS', data.items);
                }
                if (data.counters) {
                    commit('SET_COUNTERS', data.counters);
                }
                commit('SET_CURRENT_PAGE', data.current)
                commit('SET_TOTAL_PAGES', data.total_pages)
            }
        });
    },

    starredIdea({ commit }, payload) {
        let starred = payload.starred;
        return http.post(`/api/ideas/${payload.ideaId}/${starred}`)
            .then(data => {
                commit('UPDATE_IDEA', {
                    ideaId: payload.ideaId,
                    data
                });
            });
    },

    toggleLike({ commit }, payload) {
        payload.actions.reduce((promise, action) => {
            return promise.then(result => {
                return http.post(`/api/ideas/${payload.ideaId}/${action}`)
                    .then(data => Object.assign(result, data));
            });
        }, Promise.resolve({}))
            .then(data => {
                commit('UPDATE_IDEA', {
                    ideaId: payload.ideaId,
                    data
                });
            });
    },

    deleteIdea({ commit }, payload) {
        return http.post(`/api/ideas/${payload.ideaId}/delete`)
            .then((data) => {
                commit('DELETE_IDEA', { ideaId: payload.ideaId });
            });
    },

    loadCategories({commit}) {
        return http.get('/api/ideas/categories')
            .then((data) => {
                commit('SET_CATEGORIES', data);
            });
    },

    setFilter({state, commit, dispatch}, filter) {
        let q = state.query;
        q.filter = filter;
        q.categories = [];
        commit('SET_QUERY', q);
        dispatch('loadIdeas');
    },

    setSort({state, commit, dispatch}, sort) {
        let q = state.query;
        q.sort = sort;
        commit('SET_QUERY', q);
        dispatch('loadIdeas');
    },

    loadIdea({state, dispatch, commit}) {
        return http.get('/api/ideas/'+state.currentIdeaId).then((data)=>{
            commit('SET_IDEA', data);
            // dispatch('toggleSearch', false, { root: true })
        })
    },

    saveComment ({ commit }, { ideaId, parentId, text }) {
        return http.post(`/api/ideas/${ideaId}/comment`, {
            text,
            parent_id: parentId || null
        })
    },

    updateComment ({ commit }, { commentId, text }) {
        return http.post('/api/comments/edit', {
            id: commentId,
            comment: text
        })
    },

    deleteComment ({ commit }, { commentId }) {
        return http.post('/api/comments/remove', { id: commentId })
    },

    pinComment ({ commit }, { ideaId, commentId }) {
        return http.post(`/api/ideas/${ideaId}/pinComment`, { comment_id: commentId })
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/ideas.js